<template>
  <div id="nova" class="panel-shell min-h-screen dark:bg-surface-dark">
    <MainSidebar />

    <div class="panel-shell__main">
      <MainHeader />

      <div
        dusk="content"
        class="panel-shell__content pt-[calc(var(--mobile-nav-total)+1rem)] lg:pt-0"
      >
        <div class="w-full min-w-0 space-y-8 overflow-x-hidden">
          <Breadcrumbs v-if="breadcrumbsEnabled" class="min-w-0 lg:hidden" />

          <FadeTransition>
            <slot />
          </FadeTransition>

          <Footer />
        </div>
      </div>
    </div>

    <PWAInstallPrompt />
    <PWAUpdatePrompt />
    <LogoutConfirmModal />
    <FormAbandonConfirmModal />
  </div>
</template>

<script>
import MainHeader from '@/layouts/MainHeader'
import MainSidebar from '@/layouts/MainSidebar'
import Footer from '@/layouts/Footer'
import PWAInstallPrompt from '@/components/PWAInstallPrompt'
import PWAUpdatePrompt from '@/components/PWAUpdatePrompt'
import LogoutConfirmModal from '@/components/Modals/LogoutConfirmModal'
import FormAbandonConfirmModal from '@/components/Modals/FormAbandonConfirmModal'

export default {
  components: {
    MainHeader,
    MainSidebar,
    Footer,
    PWAInstallPrompt,
    PWAUpdatePrompt,
    LogoutConfirmModal,
    FormAbandonConfirmModal,
  },

  mounted() {
    Nova.$on('error', this.handleError)
    Nova.$on('token-expired', this.handleTokenExpired)
  },

  beforeUnmount() {
    Nova.$off('error', this.handleError)
    Nova.$off('token-expired', this.handleTokenExpired)
  },

  methods: {
    handleError(message) {
      Nova.error(message)
    },

    handleTokenExpired() {
      Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
        action: {
          onClick: () => Nova.redirectToLogin(),
          text: this.__('Reload'),
        },
        duration: null,
        type: 'error',
      })

      setTimeout(() => {
        Nova.redirectToLogin()
      }, 5000)
    },
  },

  computed: {
    breadcrumbsEnabled() {
      return Nova.config('breadcrumbsEnabled')
    },
  },
}
</script>
